export const company_profile_form_strings = {
  title: "Company Profile",

  contactDetailsSectionTitle: "Contact Details",
  companyInfoSectionTitle: "Company Info",

  nameLabel: "Company Name",
  namePlaceholder: "Enter your company name",
  dbaLabel: "Doing Business As (DBA)",
  dbaPlaceholder: "Enter your DBA name (optional)",
  emailLabel: "Email Address",
  emailPlaceholder: "Enter your company email",
  phoneLabel: "Phone Number",
  phonePlaceholder: "Enter your company phone (e.g., +15551234567)",
  websiteLabel: "Website",
  websitePlaceholder:
    "Enter your company website (e.g., https://www.company.com)",
  yearFoundedLabel: "Year Founded",
  yearFoundedPlaceholder: "Enter the year your company was founded",
  logoSectionTitle: "Company Logo",
  currentLogoLabel: "Current Logo",
  logoAlt: "Company Logo",
  logoUrlLabel: "Logo URL",
  selectLogoFile: "Select Logo File",
  logoUploadHint: "Upload a company logo (JPG, PNG, GIF, WebP)",
  addressSectionTitle: "Address Information",
  socialUrlsSectionTitle: "Social Media URLs",

  cancel: "Cancel",
  save: "Save",
};
